import { action } from 'app/actions';

export const GET_EVALUATIONS = 'student-simulated/GET_EVALUATIONS';
export const getEvaluations = (payload) => action(GET_EVALUATIONS, { payload });

export const GENERATE_BATCH_PDF = 'student-simulated/GENERATE_BATCH_PDF';
export const generateBatchPdf = (payload) => action(GENERATE_BATCH_PDF, { payload });

export const GET_ES_FILTERS_COMPONENTS = 'student-simulated/getESFiltersComponents';
export const getESFiltersComponents = (payload) => action(GET_ES_FILTERS_COMPONENTS, { payload });

export const GET_ESGRADE_STUDENT_QUESTIONS = 'student-simulated/GET_ESGRADE_STUDENT_QUESTIONS';
export const getESGradeStudentQuestions = (payload) =>
  action(GET_ESGRADE_STUDENT_QUESTIONS, { payload });

export const GET_ESGRADE_BY_DISCIPLINE = 'student-simulated/getESGradeByDiscipline';
export const getESGradeByDiscipline = (payload) => action(GET_ESGRADE_BY_DISCIPLINE, { payload });

export const GET_ESGRADE_REPORT_STUDENT = 'student-simulated/GET_ESGRADE_REPORT_STUDENT';
export const getESGradeReportStudent = (payload) => action(GET_ESGRADE_REPORT_STUDENT, { payload });

export const GET_ES_QUESTIONS_DETAILS_BY_COMPONENTS =
  'student-simulated/getESQuestionsDetailsByComponents';
export const getESQuestionsDetailsByComponents = (payload) =>
  action(GET_ES_QUESTIONS_DETAILS_BY_COMPONENTS, { payload });

export const GET_ESGRADE_DETAIL_ALTERNATIVE_REPORT =
  'student-simulated/GET_ESGRADE_DETAIL_ALTERNATIVE_REPORT';
export const getESGradeDetailAlternativeReport = (payload) =>
  action(GET_ESGRADE_DETAIL_ALTERNATIVE_REPORT, { payload });

export const GET_ES_EVALUATIONS_CICLE_STUDENT =
  'student-simulated/GET_ES_EVALUATIONS_CICLE_STUDENT';
export const getESEvaluationsCicleStudent = (payload) =>
  action(GET_ES_EVALUATIONS_CICLE_STUDENT, { payload });

export const GET_ESGRADE_DETAIL_BY_STUDENT = 'student-simulated/GET_ESGRADE_DETAIL_BY_STUDENT';
export const getESGradeDetailByStudent = (payload) =>
  action(GET_ESGRADE_DETAIL_BY_STUDENT, { payload });

export const GET_GROUPS = 'student-simulated/GET_GROUPS';
export const getGroups = (payload) => action(GET_GROUPS, { payload });

export const GET_ES_QUESTION_DETAIL = 'student-simulated/GET_ES_QUESTION_DETAIL';
export const getESQuestionDetail = (payload) => action(GET_ES_QUESTION_DETAIL, { payload });

export const GET_ESSAY_SSO_URL = 'student-simulated/GET_ESSAY_SSO_URL';
export const getEssaySsoUrl = (payload) => action(GET_ESSAY_SSO_URL, { payload });
